import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const Header = dynamic(() => import('./Header'));

export const defaultOptions = {
	copy: '<p><strong>Time is <u>LIMITED</u> to File!</strong></p>',
	logo: {
		'@type': '@builder.io/core:Reference',
		id: '65145887550344c68e37ac08ce75d9a4',
		model: 'header-logo',
	},
	logoHeight: 50,
	usePageColors: true,
	backgroundColor: '#555555',
	textColor: '#fff',
	variant: 'Default' as const,
	mobileStack: true,
	mobileLogo: true,
	mobileText: true,
	mobileButton: true,
	isSticky: false,
} as const;

Builder.registerComponent(Header, {
	name: 'Header',
	inputs: [
		{
			name: 'copy',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: defaultOptions.copy,
		},
		{
			name: 'logo',
			friendlyName: 'Logo',
			type: 'reference',
			model: 'header-logo',
			defaultValue: defaultOptions.logo,
		},
		{
			name: 'logoHeight',
			friendlyName: 'Logo Height',
			type: 'number',
			defaultValue: defaultOptions.logoHeight,
			helperText: 'Height of the logo in pixels',
			min: 0,
			max: 100,
			showIf: function (options) {
				return options.get('logo') !== null;
			},
		},
		{
			name: 'variant',
			friendlyName: 'Variant',
			type: 'string',
			required: true,
			enum: ['Default', 'Wide'],
			defaultValue: defaultOptions.variant,
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: defaultOptions.usePageColors,
			helperText: `If true, will use colors set on page for styling;
			if false, use the controls below`,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
			helperText: 'Be sure to select a color light enough for the text to have contrast',

			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: defaultOptions.textColor,
			helperText: 'Be sure to select a color light enough for the text to have contrast',

			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'mobileStack',
			friendlyName: 'Stack on Mobile',
			type: 'boolean',
			defaultValue: defaultOptions.mobileStack,
			helperText: 'Stack the header elements in a column at mobile sizes.',
		},
		{
			name: 'mobileLogo',
			friendlyName: 'Mobile Logo',
			type: 'boolean',
			defaultValue: defaultOptions.mobileLogo,
			helperText: 'Should the logo be shown at mobile sizes?',
		},
		{
			name: 'mobileText',
			friendlyName: 'Mobile Text',
			type: 'boolean',
			defaultValue: defaultOptions.mobileText,
			helperText: `Should text be shown at mobile sizes?
				Will default to mobile text only if none are selected.`,
		},
		{
			name: 'mobileButton',
			friendlyName: 'Mobile Button',
			type: 'boolean',
			defaultValue: defaultOptions.mobileButton,
			helperText: `If there is a button present, should it be shown at mobile sizes?
				Button is not recommended when layout is not stacked.`,
		},
		{
			name: 'isSticky',
			friendlyName: 'Sticky',
			type: 'boolean',
			defaultValue: defaultOptions.isSticky,
			helperText: 'Pin the header to the top of the viewport as the user scrolls.',
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $in: ['Button'] } },
	},
	image: getIconUrl(Icon.HEADER),
});
